// // Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { logOT } from '@shared/loggingShared'
import { EthAddr } from '@shared/SchemaTypes'
import { TicketCTO, TicketStatusEnum } from '@shared/TicketCTO'
import axios from 'axios'
import { User } from 'oidc-client-ts'

export const fetchTickets = async (
  serverApiBaseUrl: string,
  restAPIKey: string,
  ticketStatus?: TicketStatusEnum,
  poolAddr?: EthAddr
): Promise<TicketCTO[]> => {
  let url = `${serverApiBaseUrl}/tickets`
  if (ticketStatus && poolAddr) {
    url = url + `?ticketStatus=${ticketStatus}&poolAddr=${poolAddr}`
  } else if (ticketStatus) {
    url = url + `?ticketStatus=${ticketStatus}`
  } else if (poolAddr) {
    url = url + `?poolAddr=${poolAddr}`
  }
  const r = await axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': restAPIKey,
    },
  })

  return r.data.tickets
}

export const ticketPut = async (
  serverApiBaseUrl: string,
  restAPIKey: string,
  cognitoUser: User,
  ticketCTO: TicketCTO | undefined,
  completedTicketId: string | undefined
): Promise<TicketCTO> => {
  const accessToken = cognitoUser.access_token
  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': restAPIKey,
      Authorization: `Bearer ${accessToken}`,
    },
  }
  const body = {
    ticketCTO,
    completedTicketId,
  }
  const r = await axios.put(`${serverApiBaseUrl}/tickets/`, body, config)
  const data = r.data
  logOT.debug('ticketPut success', data)
  return data.ticket
}
